'use es6';

import { isNil } from 'dashboard-lib/private/js-util';
import get from 'transmute/get';
import { getComponent } from './message';
import { jsx as _jsx } from "react/jsx-runtime";
export const createDisabledMessage = (params, problemId, problemToMessage) => {
  if (isNil(problemId)) {
    return null;
  }
  const ProblemComponent = getComponent(get(problemId, problemToMessage));
  return ProblemComponent && (() => /*#__PURE__*/_jsx(ProblemComponent, Object.assign({}, params)));
};